import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { FaHeart, FaRegHeart } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { isUserLoggedIn } from "../../utils/isAuthenticated";
import LoginForm from "../authcomponents/LoginForm";
import { showErrorToast, showSuccessToast } from "../../utils/toaster";
import { DataProvider } from "../ContextProvider";
import { baseurl } from "../../config/url";

function Product({ product }) {
  const navigate = useNavigate();
  let { isLoginDialogOpen, issetLoginDialogOpen } = useContext(DataProvider);
  const [isInWishlist, setIsInWishlist] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // Check if user is logged in
    const userId = localStorage.getItem("userId");
    setIsAuthenticated(!userId);
  }, []);

  const handleNavigateToProductDetails = (productId) => {
    navigate(`/product/details/${productId}`);
  };

  useEffect(() => {
    const fetchWishlistStatus = async () => {
      if (!product || !product._id) return;
      try {
        const userId = localStorage.getItem("userId");
        if (!userId) return;

        const response = await axios.get(
          `${baseurl}/api/wishlist/get-wishlist/${userId}`
        );
        const wishlistItems = response?.data?.items || [];
        const isProductInWishlist = wishlistItems.some(
          (item) => item.productId._id === product._id
        );
        setIsInWishlist(isProductInWishlist);
      } catch (error) {
       // console.error("Error fetching wishlist status:", error);
      }
    };

    fetchWishlistStatus();
  }, [product]);

  const handleToggleWishlist = async () => {
    const userId = localStorage.getItem("userId");
    if (!isUserLoggedIn()) {
      issetLoginDialogOpen(true);
      return;
    }

    try {
      // const userId = localStorage.getItem("userId");
      if (isInWishlist) {
        // Remove from wishlist
        await axios.post(`${baseurl}/api/wishlist/remove`, {
          userId,
          productId: product._id,
        });
        setIsInWishlist(false);
        showSuccessToast(`${product.name} removed from your wishlist.`);
      } else {
        // Add to wishlist
        await axios.post(`${baseurl}/api/wishlist/add`, {
          userId,
          productId: product._id,
        });
        setIsInWishlist(true);
        showSuccessToast(`${product.name} added to your wishlist.`);
      }
    } catch (error) {
      console.error("Error toggling wishlist:", error);
      showErrorToast("Failed to update wishlist.");
    }
  };

  return (
    <div
      key={product._id}
      className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 ease-in-out flex flex-col"
    >

      <div
        className="w-full h-60 sm:h-72 md:h-80 overflow-hidden cursor-pointer"
        onClick={() => handleNavigateToProductDetails(product._id)}
      >
        {/* <img
        src={`data:${product?.image?.contentType};base64,${product?.image?.data}`}
        alt={product.name}
        className="w-full h-full object-contain"
        // onClick={() => handleNavigateToProductDetails(product._id)}
      /> */}
        <img
          src={product.image || "/no-image.png"}
          alt={product.name}
          className="w-full h-full object-contain"
        />

      </div>

      <div className="p-4 flex flex-col flex-grow">
        <div className="flex justify-between items-center">
          <h3 className="md:text-xl text-lg font-semibold text-gray-800 truncate">
            {product.name}
          </h3>
          {/* Wishlist toggle button */}
          <button
            className="text-2xl cursor-pointer"
            onClick={handleToggleWishlist}
          >
            {isInWishlist ? (
              <FaHeart className="text-red-600" />
            ) : (
              <FaRegHeart className="text-gray-600" />
            )}
          </button>
        </div>
        <p className="text-gray-600 text-sm mt-2">Description :{product.description}</p>
        <p className="text-gray-700 mt-2"><strong>Sold By :</strong> {product.seller?.companyName}</p>
        <p className="mt-2 text-lg font-semibold text-gray-900">
          Price: ₹{product.price} </p>



      </div>
      {showLoginModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96">
            <LoginForm closeLoginDialog={() => setShowLoginModal(false)} />
          </div>
        </div>
      )}
    </div>
  );
}

export default Product;
